module.exports = __webpack_public_path__ + "img/feature-browsers.2d79c467c6af6ffce1d9f74557df6819.png";